import React from "react";
import { Typography, Box, Stack, Avatar } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

import { Images } from "./../../assets/common";
import { useHistory } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import { fullName, isOwnerId } from "./../../constants/function";
import { addSongAction } from "./../../action/songs";
import { useSelector, useDispatch } from "react-redux";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DropMenu from "../DropMenu";
import AddMusicToPlaylist from "../AddMusicToPlaylist";
import OutsideClickHandler from "react-outside-click-handler";
import MusicCard from "../MusicCard";
import notifier from "../Notifier";
import NoData from "../Nodata";
import { useTranslation } from "react-i18next";
import "./index.scss";
export default function SearchResult({
  users,
  musics,
  playlists,
  handleClose,
  keyword,
  onShowAddPlaylist,
}) {
  const { t } = useTranslation("common");
  const [open, setOpen] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [selectedId, setSelectedAlbum] = React.useState();

  const songs = useSelector((state) => state.songs);
  const previousSong = React.useRef(songs);
  const dispatch = useDispatch();
  const history = useHistory();
  const [showPlaylist, setShowPlaylist] = React.useState(false);

  React.useEffect(() => {}, [songs]);
  const toggleDrawer = (value, id, index, song) => {
    setOpen(value);
    setSelectedIndex(index);
    if (value && id) {
      setOpen(false);
      makeAction(value, id, index, song);
    }
  };
  const makeAction = (key, id, index, song) => {
    switch (key) {
      case "m2":
        if (
          !isOwnerId(
            song["owner"]
              ? song["owner"]["_id"]
              : song["uploader"]
              ? song["uploader"]["_id"]
              : ""
          ) &&
          song["private"] &&
          ((song["owner"] && !song["owner"]["isSubscribed"]) ||
            (song["uploader"] && !song["uploader"]["isSubscribed"]))
        )
          notifier.error(t("notifier.error.toast5"));
        else {
          dispatch(addSongAction(musics[index], null, true));
          handleClose();
        }
        break;
      case "m3":
        if (
          !isOwnerId(
            song["owner"]
              ? song["owner"]["_id"]
              : song["uploader"]
              ? song["uploader"]["_id"]
              : ""
          ) &&
          song["private"] &&
          ((song["owner"] && !song["owner"]["isSubscribed"]) ||
            (song["uploader"] && !song["uploader"]["isSubscribed"]))
        )
          notifier.error(t("notifier.error.toast5"));
        else {
          onShowAddPlaylist(id, true);
          handleClose();
        }
        break;
      case "m1":
        handleClose();
        song["nftId"]
          ? history.push(`/app/SongDetail/${song["nftId"]}`)
          : history.push(`/app/SongDetails/${id}`);
        break;
      default:
        break;
    }
  };

  const playSong = (song) => {
    if (
      !isOwnerId(
        song["owner"]
          ? song["owner"]["_id"]
          : song["uploader"]
          ? song["uploader"]["_id"]
          : ""
      ) &&
      song["private"] &&
      ((song["owner"] && !song["owner"]["isSubscribed"]) ||
        (song["uploader"] && !song["uploader"]["isSubscribed"]))
    )
      notifier.error(t("notifier.error.toast5"));
    else {
      handleClose();
      dispatch(addSongAction(song));
    }
  };
  return (
    <Box className="__Search_result_box">
      <Box
        className="__main_pading scroll_display"
        style={{
          maxHeight: "77vh",
          overflowY: "scroll",
          paddingBottom: "80px",
        }}
      >
        {musics && musics.length > 0 ? (
          <Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-end"
            >
              <Typography className="fs-17 fw-b">
                {t("searchResult.header1")}
              </Typography>
              <Typography
                className="fs-13 fw-b canceled _cp"
                onClick={() => {
                  handleClose();
                  history.push(
                    `/app/searchMusic/${encodeURIComponent(keyword)}`
                  );
                }}
              >
                {t("searchResult.all")}
              </Typography>
            </Stack>
            <Stack className="music_result">
              {musics.length > 0 &&
                musics.map((song, index) => (
                  <Box key={index} sx={{ position: "relative" }}>
                    <Stack
                      sx={{
                        marginTop: "0px !important",
                      }}
                      className="_cp"
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Stack direction="row" alignItems="center" gap="10px">
                        <Stack className="__music_thumb _cp">
                          <Avatar
                            src={
                              song["thumbnailImg"]
                                ? song["thumbnailImg"]["filePath"]
                                : Images.dummy
                            }
                          />
                          <img
                            onClick={() => playSong(song)}
                            className="__play_hover"
                            src={Images.play}
                            alt="play"
                          />
                        </Stack>
                        <Stack direction="column">
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <Typography className="fs-16 fw-b">
                              {song["title"]}
                            </Typography>
                            {song["private"] ? (
                              <LockIcon
                                sx={{
                                  width: "11px",
                                  height: "11px",
                                  padding: "2px",
                                  color: "#989898",
                                  backgroundColor: "#4E4E4E",
                                }}
                                className="__small_icon"
                              />
                            ) : null}
                          </Stack>

                          <Stack
                            direction="row"
                            alignItems="center"
                            // spacing={1}
                            onClick={() => {
                              // song[index].track.pause();
                              handleClose();
                              // history.push(
                              //   `/app/ArtistProfile/${song["uploader"]["_id"]}`
                              // );
                            }}
                            sx={{
                              overflowX: "scroll",
                              gap: "6px",
                              width: "245px",
                            }}
                            className="scroll_display_musicCard"
                          >
                            {song.artistData ? (
                              song.artistData.map((a, index) => (
                                <Typography
                                  className="fs-14 fade-text-60"
                                  key={index}
                                  // onClick={() => {
                                  //   history.push(`/app/ArtistProfile/${a.uId}`);
                                  //   handleClose();
                                  // }}
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  {a?.displayArtistName}
                                  {index == song.artistData.length - 1
                                    ? ""
                                    : ","}
                                </Typography>
                              ))
                            ) : (
                              <Typography className="fs-14 fade-text-60">
                                {fullName(song["uploader"])}
                              </Typography>
                            )}

                            {song["uploader"]["isVerified"] ? (
                              <DoneIcon
                                color="primary"
                                sx={{
                                  backgroundColor: "#1E1E1E",
                                  border: "1px solid #FFEE20",
                                  borderRadius: "50%",
                                  fontSize: "10px",
                                  padding: "2px",
                                }}
                              />
                            ) : null}
                          </Stack>
                        </Stack>
                      </Stack>
                      <MoreVertIcon
                        onClick={() => (
                          setOpen(!open), setSelectedIndex(index)
                        )}
                        className="__more_hover_color"
                      />
                    </Stack>
                    {open && selectedIndex === index ? (
                      <OutsideClickHandler
                        onOutsideClick={() => setOpen(false)}
                      >
                        <DropMenu
                          right={"0px"}
                          open={open}
                          actions={[
                            { key: "m2", action: t("dropMenu.m2") },
                            { key: "m3", action: t("dropMenu.m3") },
                            { key: "m1", action: t("dropMenu.m1") },
                          ]}
                          toggleMenu={(action) =>
                            toggleDrawer(action, song["_id"], index, song)
                          }
                        />
                      </OutsideClickHandler>
                    ) : null}
                  </Box>
                ))}
            </Stack>
          </Stack>
        ) : null}
        {users && users.length > 0 ? (
          <Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-end"
            >
              <Typography className="fs-17 fw-b">
                {t("searchResult.header3")}
              </Typography>
              <Typography
                className="fs-13 fw-b canceled _cp"
                onClick={() => {
                  handleClose();
                  history.push(
                    `/app/searchArtist/${encodeURIComponent(keyword)}`
                  );
                }}
              >
                {t("searchResult.all")}
              </Typography>
            </Stack>
            <Stack
              style={{ padding: "15px 10px" }}
              sx={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: "32px",
                columnGap: "58px",
                justifyContent: "center",
              }}
              // className="artist_result"
            >
              {users.length > 0 &&
                users.map((user, index) => (
                  <Stack
                    className="_cp"
                    key={index}
                    spacing={2}
                    direction="column"
                    alignItems="center"
                  >
                    <Box
                      sx={{ position: "relative" }}
                      className="__artist_thumbnail"
                    >
                      <img
                        onClick={() => {
                          handleClose();
                          history.push(`/app/ArtistProfile/${user["_id"]}`);
                        }}
                        className="__large_avatar _object-cover"
                        style={{ backgroundColor: "#383737" }}
                        src={
                          user["profileImg"] &&
                          user["profileImg"]["filePath"] &&
                          user["profileImg"]["filePath"] != ""
                            ? user["profileImg"]["filePath"]
                            : Images.user_dummy
                        }
                        alt="user"
                      />
                      <img
                        onClick={() => {
                          handleClose();
                          history.push(`/app/ArtistProfile/${user["_id"]}`);
                        }}
                        className="__play_hover_artist"
                        src={Images.play}
                        alt="play"
                      />
                    </Box>
                    <Stack
                      spacing={1}
                      direction="row"
                      alignItems="center"
                      marginTop="8px !important"
                    >
                      <Typography>{fullName(user)}</Typography>
                      {user["isVerified"] ? (
                        <DoneIcon
                          color="primary"
                          sx={{
                            backgroundColor: "#1E1E1E",
                            border: "1px solid #FFEE20",
                            borderRadius: "50%",
                            fontSize: "10px",
                            padding: "2px",
                          }}
                        />
                      ) : null}
                    </Stack>
                  </Stack>
                ))}
            </Stack>
          </Stack>
        ) : null}

        {playlists && playlists.length > 0 ? (
          <Stack>
            <Stack direction="row" justifyContent="space-between">
              <Typography className="fs-17 fw-b">
                {t("searchResult.header2")}
              </Typography>
              <Typography
                className="fs-13 fw-b canceled _cp"
                onClick={() => {
                  handleClose();
                  history.push(
                    `/app/searchStudio/${encodeURIComponent(keyword)}`
                  );
                }}
              >
                {t("searchResult.all")}
              </Typography>
            </Stack>
            <Stack
              sx={{
                display: "felx",
                // gap: "20px",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: "32px",
                columnGap: "58px",
                justifyContent: "center",
              }}
              style={{ padding: "15px 10px" }}
            >
              {playlists.length > 0 &&
                playlists.map((playlist, index) => (
                  <MusicCard
                    key={index}
                    isPlaylist={true}
                    music={playlist}
                    title="Featured Playlist"
                    route={"/app/feature/playlists"}
                    noActions={true}
                    platform={playlist?.playlistNftDetails?.platform}
                    actions={[
                      "Add all songs to Queue",
                      "Mark this Asset Private",
                      "View Statistics",
                    ]}
                    toggleMenu={(action, id, index) =>
                      toggleDrawer(action, id, index)
                    }
                    onNavigate={(isNft) => {
                      !isOwnerId(playlist["createdBy"]) &&
                      !playlist["isSubscribed"] &&
                      playlist["private"]
                        ? notifier.error(
                            "Subscribe the Artist to view the details"
                          )
                        : history.push(
                            `/app/${isNft ? "PlaylistNftDetail" : "Music"}/${
                              isNft ? playlist["nftId"] : playlist["_id"]
                            }`
                          );
                      handleClose();
                    }}
                    isSearch={true}
                  />
                ))}
            </Stack>
          </Stack>
        ) : null}
        {playlists.length === 0 && users.length === 0 && musics.length === 0 ? (
          <NoData lable={t("noData.noData")} />
        ) : null}
      </Box>

      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={selectedId}
          open={showPlaylist}
          handleClose={() => {
            setShowPlaylist(false);
          }}
        />
      ) : null}
    </Box>
  );
}
